import React from "react"
import { Maybe } from "lib/types/generated/graphql-types"
import { ReactComponent as ShippingIcon } from "images/icons/cart-flatbed-boxes.svg"
import { AttributeTag, Container, IconWrapper } from "./OrderLineShippingAttributes.styled"

type Props = {
  shippingAttributes: Maybe<string[]> | undefined
  loading: boolean
}

const OrderLineShippingAttributes = ({ shippingAttributes, loading }: Props) => {
  if (loading || !shippingAttributes || shippingAttributes.length === 0) return null

  return (
    <Container data-testid="order-line-shipping-attributes">
      <IconWrapper>
        <ShippingIcon />
      </IconWrapper>
      {shippingAttributes.map((attribute) => (
        <AttributeTag key={attribute}>{attribute}</AttributeTag>
      ))}
    </Container>
  )
}

export default OrderLineShippingAttributes
